module.exports = __webpack_public_path__ + "static/img/tips3.df5e9dd5.png";